import {Stack} from '@mui/material'
import {colors} from '@/constants'
import React from 'react'
import TransCustom from '@/components/UI/i18next'

const Index = () => {
  return (
    <Stack
      marginTop="-40px"
      width="100%"
      alignItems="center"
      justifyContent="center"
      height="100%"
      position="relative">
      <Stack width="85%" gap="40px">
        <TransCustom
          i18nKey="1399"
          textAlign="center"
          variant="button"
          color={colors.orange}
          style={{wordBreak: 'break-word'}}
        />
        <Stack gap="10px">
          <TransCustom
            i18nKey="1400"
            textAlign="center"
            variant="body1"
            style={{wordBreak: 'break-word'}}
          />
          <TransCustom
            i18nKey="1326"
            textAlign="center"
            variant="body1"
            color={colors.gray}
          />
          <TransCustom
            i18nKey="1410"
            textAlign="center"
            variant="body1"
            style={{wordBreak: 'break-word'}}
          />
          <TransCustom
            i18nKey="1326"
            textAlign="center"
            variant="body1"
            color={colors.gray}
          />
          <TransCustom
            i18nKey="1402"
            textAlign="center"
            variant="body1"
            style={{wordBreak: 'break-word'}}
          />
        </Stack>
      </Stack>
    </Stack>
  )
}

export default Index
